import { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { Button } from '@frontierag/frontier-ui-library';
import {
  ExpandLess as ExpandLessIcon,
  ExpandMore as ExpandMoreIcon,
} from '@frontierag/frontier-ui-library/icons';
import AccordionDynamicCells from 'shared/AccordionRow/AccordionDynamicCells';
import type { IAccordionCell } from 'shared/AccordionRow/types';
import type { IGenericObject } from 'types';

import { styles } from './styles';

interface IAccordionProducts {
  products: IGenericObject[];
  productCells: IAccordionCell[];
  transNamespace: string;
}

export default function AccordionProducts({
  products,
  productCells,
  transNamespace,
}: IAccordionProducts) {
  const { t } = useTranslation(transNamespace);

  const [expanded, setExpanded] = useState(false);
  const [firstProduct, ...restProducts] = products;

  const toggleProducts = () => {
    setExpanded(!expanded);
  };

  return (
    <>
      <AccordionDynamicCells
        data={firstProduct || {}}
        dynamicCells={productCells}
        sx={styles.accordionDynamicCells}
      />
      {expanded &&
        restProducts.map((product, index) => (
          <AccordionDynamicCells
            key={`dynamic-accordion-${index}`}
            data={product}
            dynamicCells={productCells}
          />
        ))}
      {restProducts.length > 0 && (
        <Button
          sx={styles.accordionButton}
          onClick={toggleProducts}
          endIcon={expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        >
          {expanded ? (
            t('buttons.viewLess')
          ) : (
            <Trans t={t} i18nKey="buttons.viewMore" values={{ count: restProducts.length }} />
          )}
        </Button>
      )}
    </>
  );
}
